import { Subject } from 'rxjs'
import { UntypedFormControl } from '@angular/forms'
import { Directive, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core'
import { distinctUntilChanged, takeUntil } from 'rxjs/operators'

@Directive({
  selector: 'app-form-radio-group',
  standalone: false,
})
export class FormRadioGroupDirective implements OnInit, OnDestroy {
  @Input() ctrl: UntypedFormControl

  @Output() valueChange = new EventEmitter()
  $destroy = new Subject()
  constructor() {}

  ngOnInit(): void {
    if (this.ctrl) {
      this.ctrl.valueChanges.pipe(distinctUntilChanged(), takeUntil(this.$destroy)).subscribe({
        next: (v) => {
          this.valueChange.emit(v)
        },
      })
    }
  }

  ngOnDestroy() {
    this.$destroy.next()
    this.$destroy.complete()
  }
}
